import { useCallback } from 'react';
import * as dashboardService from '../services/dashboardService';

// Hook específico para dashboard
export function useDashboard() {
  const getDashboardMetrics = useCallback(
    async (
      period: 'day' | 'week' | 'month' | 'year' = 'week',
      metrics: string[] = []
    ) => {
      return await dashboardService.getDashboardMetrics(period, metrics);
    },
    []
  );

  const getDashboardConfig = useCallback(async () => {
    return await dashboardService.getDashboardConfig();
  }, []);

  const updateDashboardConfig = useCallback(async (selectedMetrics: string[]) => {
    return await dashboardService.updateDashboardConfig(selectedMetrics);
  }, []);

  const getDashboardStats = useCallback(
    async (userId: string, userRole: string) => {
      return await dashboardService.getDashboardStats(userId, userRole);
    },
    []
  );

  const getDashboardActivity = useCallback(
    async (userId: string, userRole: string, specialty?: string) => {
      return await dashboardService.getDashboardActivity(
        userId,
        userRole,
        specialty
      );
    },
    []
  );

  return {
    getDashboardMetrics,
    getDashboardConfig,
    updateDashboardConfig,
    getDashboardStats,
    getDashboardActivity,
  };
}
